import VCheckbox from '@voly/ui-components/src/v2/VCheckbox';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import VFormFieldHorizontal from '@voly/ui-components/src/v2/VFormFieldHorizontal';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import VStackRow from '@voly/ui-components/src/v2/VStackRow.jsx';
import PointFieldName from './PointFieldName';
import FieldLockedIcon from '../FieldLockedIcon';

const CHECKED_VALUE = 'true';
const UNCHECKED_VALUE = 'false';

const isTicked = (value: string): boolean => value !== '' && value !== UNCHECKED_VALUE;

interface PointFieldCheckboxProps {
  field: TCustomField;
  value: string;
  readOnly: boolean;
  onSave: (value: string) => void;
}

const PointFieldCheckbox = ({
  field,
  value,
  readOnly,
  onSave,
}: PointFieldCheckboxProps): ReactElement => {
  const handleCheckedChange = ({ checked }: { checked: boolean | 'indeterminate' }): void => {
    onSave(checked === true ? CHECKED_VALUE : UNCHECKED_VALUE);
  };

  return (
    <VFormFieldHorizontal
      data-testid="point-custom-field-row"
      size="sm"
      label={<PointFieldName field={field} />}
      helperText={field.description}
      errorText={undefined}
      invalid={undefined}
      readOnly={readOnly}
      disabled={field.lockedValue}
    >
      <VTooltip content={translate('locked_by_admin')} disabled={!field.lockedValue}>
        <VStackRow w={'fit-content'}>
          <VCheckbox checked={isTicked(value)} onCheckedChange={handleCheckedChange} />

          {field.lockedValue ? <FieldLockedIcon /> : undefined}
        </VStackRow>
      </VTooltip>
    </VFormFieldHorizontal>
  );
};

export default PointFieldCheckbox;
